/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRewardLedgerEntryHotelDetails
 */
export interface UserRewardLedgerEntryHotelDetails {
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    checkInDatetime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    checkOutDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    confirmationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    roomType?: string;
    /**
     * 
     * @type {number}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    totalCost?: number;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    bookingId?: number;
    /**
     * User-facing Gondola booking confirmation number.
     * @type {string}
     * @memberof UserRewardLedgerEntryHotelDetails
     */
    gondolaBookingId?: string;
}

/**
 * Check if a given object implements the UserRewardLedgerEntryHotelDetails interface.
 */
export function instanceOfUserRewardLedgerEntryHotelDetails(value: object): value is UserRewardLedgerEntryHotelDetails {
    return true;
}

export function UserRewardLedgerEntryHotelDetailsFromJSON(json: any): UserRewardLedgerEntryHotelDetails {
    return UserRewardLedgerEntryHotelDetailsFromJSONTyped(json, false);
}

export function UserRewardLedgerEntryHotelDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRewardLedgerEntryHotelDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'checkInDatetime': json['check_in_datetime'] == null ? undefined : (new Date(json['check_in_datetime'])),
        'checkOutDatetime': json['check_out_datetime'] == null ? undefined : (new Date(json['check_out_datetime'])),
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'roomType': json['room_type'] == null ? undefined : json['room_type'],
        'totalCost': json['total_cost'] == null ? undefined : json['total_cost'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
    };
}

export function UserRewardLedgerEntryHotelDetailsToJSON(json: any): UserRewardLedgerEntryHotelDetails {
    return UserRewardLedgerEntryHotelDetailsToJSONTyped(json, false);
}

export function UserRewardLedgerEntryHotelDetailsToJSONTyped(value?: UserRewardLedgerEntryHotelDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'check_in_datetime': value['checkInDatetime'] == null ? value['checkInDatetime'] : value['checkInDatetime'].toISOString(),
        'check_out_datetime': value['checkOutDatetime'] == null ? value['checkOutDatetime'] : value['checkOutDatetime'].toISOString(),
        'confirmation_number': value['confirmationNumber'],
        'room_type': value['roomType'],
        'total_cost': value['totalCost'],
        'currency': value['currency'],
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
    };
}

